import Cookies from "js-cookie";
import { useRef } from "react";
import { useOnce } from "src/hooks/lifecycle";
import { trackEvent } from "src/utils/api/tracker";
import {
  getInAppAutoCookie,
  getWebAuthCookie,
} from "src/utils/authCookieParser";

/**
 * Hook to track when hive-auth cookie is being mutated.
 */
export function useTrackHiveCookieMutation() {
  const startedAt = useRef(Date.now()).current;

  useOnce(() => {
    if (typeof cookieStore === "undefined") {
      return () => {};
    }

    const listener = (event: CookieChangeEvent) => {
      const { changed, deleted } = event;
      const hiveCookiesDeleted = deleted
        .filter((d) => d.name.startsWith("hive-"))
        .map((d) => d.name);
      const hiveCookiesChanged = changed
        .filter((c) => c.name.startsWith("hive-"))
        .map((c) => c.name);

      if (hiveCookiesDeleted.length > 0 || hiveCookiesChanged.length > 0) {
        trackEvent("BuyflowCookieChange", {
          changed: changed.map((c) => c.name),
          deleted: deleted.map((d) => d.name),
          startedAt,
          msSinceLoad: Date.now() - startedAt,
          hasHiveAuthCookie: !!Cookies.get("hive-auth"),
          autologinDataCookieSet: !!getInAppAutoCookie(),
          identityDataCookieSet: !!getWebAuthCookie(),
        });
      }
    };
    cookieStore.addEventListener("change", listener);
    return () => {
      cookieStore.removeEventListener("change", listener);
    };
  });
}
